// eslint-disable-next-line
export const LIKED_PRODUCTS_ADD = 'LIKED_PRODUCTS_ADD';
